import React from 'react'

import EDIT_ICON from '@public/assets/action/icon_edit.svg'
import ZOOM_ICON from '@public/assets/action/icon_zoom.svg'
import QUESTION_ICON from '@public/assets/button/question-solid.svg'
import TUTORIAL_VIDEO from '@public/assets/welcome-wizard/reassign-matters-tutorial-video.mp4'
import { useWelcomeWizardVideo } from '../../hooks/useWelcomeWizardVideo'

function ReassignMattersStep() {
  const videoRef = useWelcomeWizardVideo(TUTORIAL_VIDEO)

  return (
    <div className="max-w-[900px]">
      <section>
        <h3 className="text-lg font-semibold">
          Need to update the matter after a time entry has been accepted?
        </h3>

        <div className="mt-3 text-base leading-[1.35] tracking-[0.5px] text-[#666]">
          <p>
            You can change matter assignments anytime before an entry is
            released using either of the methods below.
          </p>

          <ul className="mt-1 space-y-1 pl-6">
            <li className="list-disc pl-0.5">
              <div className="inline-flex flex-wrap items-center gap-x-2 gap-y-1">
                <span>
                  <strong className="font-semibold">Edit:</strong> Hover over
                  the Status column and click
                </span>
                <span className="inline-flex h-6 w-6 shrink-0 items-center justify-center rounded-full border border-[#d9d9d9] bg-white">
                  <img alt="Edit" className="h-3.5 w-3.5" src={EDIT_ICON} />
                </span>
                <span>to update the matter.</span>
              </div>
            </li>

            <li className="list-disc pl-0.5">
              <strong className="font-semibold">Drag and drop:</strong> Drag a
              time entry directly, or select multiple entries and drag them to
              the desired matter group.
            </li>

            <li className="flex list-none items-center rounded-lg border border-[#d9d9d9] bg-[#f5f5f5] px-5 py-2">
              <img
                alt=""
                className="mr-2.5 size-[17.5px]"
                src={QUESTION_ICON}
              />
              <div>
                <p className="text-sm font-bold leading-[1.42] tracking-normal text-[#333]">
                  {`Don't see the matter you need in the Time Entry panel?`}
                </p>
                <p className="text-sm leading-[1.42] tracking-normal">
                  The Time Entry grid only shows recent matters. Create a new
                  Matter Workspace directly from the panel through{' '}
                  <span className="inline-flex items-center gap-1 rounded-full px-1 align-middle text-xs leading-none tracking-normal text-[#333]">
                    <img alt="" className="h-3.5 w-3.5" src={ZOOM_ICON} />
                    Recent Matters
                  </span>
                  , then drag and drop activities to create your time entry.
                </p>
              </div>
            </li>
          </ul>
        </div>
      </section>

      <video
        ref={videoRef}
        className="mt-3 aspect-[900/518] w-full rounded-[20px] bg-black object-contain shadow-[0_1px_2px_rgba(0,0,0,0.3),0_2px_6px_2px_rgba(0,0,0,0.15)]"
        controls
        autoPlay
        key={TUTORIAL_VIDEO}
        preload="metadata"
      >
        <source src={TUTORIAL_VIDEO} type="video/mp4" />
      </video>
    </div>
  )
}

export default ReassignMattersStep
